import { FC } from "react";
import { useTranslation } from "react-i18next";
import { Button } from "../../Common/Button";
import { Spinner } from "../../Common/Spinner";
import { StyledWrap } from "./style";

type Props = {
  backgroundColor: string;
  isSubmitting: boolean;
  onClick: () => void;
};

const ComposeBtn: FC<Props> = ({ backgroundColor, isSubmitting, onClick }) => {
  const { t } = useTranslation();
  return (
    <StyledWrap backgroundColor={backgroundColor}>
      <Button
        onClick={onClick}
        fullwidth
        className="composeBtn"
        hasIcon={isSubmitting}
        disabled={isSubmitting}
      >
        {isSubmitting && <Spinner size="xs" />}
        {t("components.sharepoint.bttCompose")}
      </Button>
    </StyledWrap>
  );
};

export default ComposeBtn;
